import { PluginDefinition } from 'yam-types'
import apisixOperator from './handlers/apisix'
import { name, version } from './package.json'
import * as schema from './schema.json'
import * as settings from './settings.json'
import { AccessApproachConfig } from './types.d'

export default {
  name,
  schema,
  settings,
  version,
  handlers: {
    'access[*]': apisixOperator
  }
} as PluginDefinition<AccessApproachConfig>